import { validate } from 'sha-el-design/lib';
import { QuestionnaireMutationInput } from '../../../../schema';

export const questionnaireSchema = validate<QuestionnaireMutationInput>(validate.Object({
  name: validate.Text().required('Name is required'),
  state: validate.Text().required('State is required'),
  town: validate.Text().required('Town is required'),
  questions: validate.Text().required('Question is required'),
}));

export const mutation = `mutation CreateQuestionnaire($input: QuestionnaireMutationInput!) {
  createQuestionnaire(input: $input) {
      name
      id
      town
      state
      questions
      errors {
        field
        messages
      }
    }
}`;

// The statements MUST be fetched here: the list's Activate/Deactivate button
// re-sends the whole row through the full-replacement mutation, so any model
// field missing from this query would be silently blanked on toggle -- and
// every production questionnaire carries a hand-written call script.
export const questionnaireListQuery = `
  query allQuestionnaires($after: String!, $name: String, $state: ID){
    allQuestionnaires(first:20, after:$after, name_Icontains:$name, state_Name_Icontains:$state) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          state {
            id
            name
          }
          town {
            id
            name
          }
          questions
          active
          openingStatement
          closingStatement
        }
      }
    }
  }
`;

// `active` is fetched so the edit form can PRESERVE it -- submit used to
// hardcode active:true, silently re-activating any questionnaire you edited.
export const questionnaireDetailsQuery = `query questionnaire($id: ID!){
  questionnaire(id: $id) {
    id
    name
    active
    openingStatement
    closingStatement
    town {
      id
      name
    }
    state {
      id
      name
    }
    questions
    allQuestions {
      id
      name
    }
  }
}`;
